import { Link } from 'react-router-dom';

import React from 'react';
import { numberToUSFormat } from '@/shared/helpers';

export const TABLE_COLUMNS = [
    {
        Header: "Merchant",
        accessor: "name",
        Footer: "Total",
    },
];

export const tableColumns = (config) => {
    const res = config.columns.map(item => ({
        Header: item.label,
        accessor: item.key,
        width: item.width,
        className: item.key == 'name' ? 'frozenColumnLeft0' : '',
        Cell: ({ row, value }) => {
            if (item.type === 'float') {
                if(!!item.prefix){
                    value = numberToUSFormat(value, true, item.prefix || "$");
                }else{
                    value = value + item.suffix
                }
            }
            return value;
            
        },
        Footer: (info) => {
            const totalValue = config.total[item.key];
            if (item.type === 'float') {
                if (!!item.prefix) {
                    return <span>{numberToUSFormat(totalValue, true, item.prefix || "$")}</span>;
                }
            }
            return <span>{item.prefix || ''}{totalValue}{item.suffix || ''}</span>;
        },
    }));
    return res;
}

